module.exports = __webpack_public_path__ + "static/media/bay2022FeaturesBanner_Desktop_1220x150_@1x.c6041188.jpg";